import { render } from "./upcoming-court.vue?vue&type=template&id=d5737934"
import script from "./upcoming-court.vue?vue&type=script&lang=js"
export * from "./upcoming-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__